export default "__VITE_ASSET__BX$te0tb__"